module.exports = new __parcel__URL__("mining_success_badge.068e1c65.png").toString();